export default {
    ACTION: {
        AUTH: "auth",
        SUBSCRIBE: "subscribe",
        STAT: "stat",
        PROPAGATE: "propagate",
    },
    COMMON: {
        AUTH_TIMEOUT: "auth.timeout",
        CONNECT: "socket.connect",
        DISCONNECT: "socket.disconnect",
        RECONNECT: "socket.reconnect",
        CONNECT_ERROR: "socket.connect.error",
    },
    MESSAGE: {
        MEMBER_TO_PERFORMER_LIVE: "notification.performer.member.message.delivery.live",
        MEMBER_TO_PERFORMER_HISTORY: "notification.performer.member.message.delivery.history",
        PERFORMER_TO_MEMBER_LIVE: "notification.member.performer.message.delivery.live",
        PERFORMER_TO_MEMBER_HISTORY: "notification.member.performer.message.delivery.history",
        PERFORMER_MESSAGE_SENT: "notification.performer.message.sent.delivery.live",
        MEMBER_MESSAGE_SENT: "notification.member.message.sent.delivery.live",
        MESSENGER_MESSAGE_UPDATED: "notification.messenger.message-updated.delivery.live",
    },
    NOTIFICATION: {
        SUBSCRIPTION_FAILED: "notification.subscription.subscription.creation_failed.delivery.live",
        SUBSCRIPTION_CREATED: "notification.subscription.subscription.created.delivery.live",
        SUBSCRIPTION_INACTIVATED: "notification.subscription.subscription.inactivated.delivery.live",
        RECURRENT_SUBSCRIPTION_CREATED: "notification.recurrent_subscription.model.subscription.created.delivery.live",
        COMPETITOR_REWARDED: "notification.competition.competitor.rewarded.delivery.live",
        FAVOURITE_ADDED: "notification.performer.member.favourite.added.delivery.live",
        CHANNEL_CONTENT_COMMENTED: "notification.channel.content.commented.delivery.live",
        CHANNEL_CONTENT_LIKED: "notification.channel.content.liked.delivery.live",
        IMAGEFOLDER_SUBSCRIBED: "notification.mycontent.imagefolder.subscription.created.delivery.live",
        VIDEO_SUBSCRIBED: "notification.mycontent.video.subscription.created.delivery.live",
        PERFORMER_STATUS_UPDATED: "notification.performer.status.updated.delivery.live",
        PROFILE_PICTURE_ACCEPTED: "notification.performer.channel.profile_picture.status.accepted.delivery.live",
        PROFILE_PICTURE_REJECTED: "notification.performer.channel.profile_picture.status.rejected.delivery.live",
        VIP_SHOW_SUBSCRIBED: "notification.member.show.subscribed.delivery.live",
        VIP_SHOW_UNSUBSCRIBED: "notification.member.show.unsubscribed.delivery.live",
        CHAT_TYPE_CHANGE: "notification.member.chat_type.changed.delivery.live",
        SURPRISE_REWARD_ADDED: "notification.member.surprise.reward.added.delivery.live",
        PERFORMER_WENT_ONLINE: "notification.performer_went_online.delivery.live",
        AFTER_PAY_STATUS_CHANGED: "notification.after_pay.member_status_updated.delivery.live",
        AFTER_PAY_PAYMENT_RETRY_UPDATED: "notification.payment.after_pay.purchase_transaction_retried.delivery.live",
    },
    PERFORMER: {
        PUBLIC_STREAM_STATUS_UPDATE: "performer.public_stream.status_updated",
        LEGACY_STATUS_CHANGE: "legacy.performer.status.change",
        STATUS_CHANGED: "performers.status.changed",
        SHOW_CREATED: "performer.show.created.withperformer",
        SHOW_CANCELLED: "performer.show.cancelled.withperformer",
        SHOW_STARTED: "performer.show.started.withperformer",
        SHOW_ENDED: "performer.show.ended.withperformer",
        CHANGED: "performer.performer.changed",
        VIDEO_CALL_STATUS_CHANGE: "performer.vc.status.change",
        COUNTRY_BAN_CHANGE: "performer.country_ban.changed",
        ACHIEVEMENT_LEVEL_CHANGED: "msc.achievement.level.changed",
    },
    MEMBER: {
        SESSION_CHANGE: "notification.member.session.changed.delivery.live",
        SMART_BUY_SUCCESS: "notification.member.payment.smartbuy.successful.delivery.live",
        LOYALTY_CHANGED: "notification.member.loyalty.changed.delivery.live",
        LEVEL_CHANGED: "notification.member.loyalty.level.changed.delivery.live",
        LEVEL_POINTS_CHANGED: "notification.member.loyalty.level_points.changed.delivery.live",
        DISPLAY_LEVEL_CHANGED: "notification.member.loyalty.display_level.changed.delivery.live",
        DISPLAY_LEVEL_DELETED: "notification.member.loyalty.display_level.deleted.delivery.live",
        FEEDBACK_LEVEL_CHANGED: "notification.member.loyalty.feedback.level.changed.delivery.live",
        FEEDBACK_LEVEL_POINTS_CHANGED: "notification.member.loyalty.feedback.level_points.changed.delivery.live",
        BENEFIT_STATUS_CHANGED: "notification.loyalty.member_benefit_status_changed.delivery.live",
        FREE_UNITS_BALANCE_CHANGED: "notification.member.free_units.balance.changed.delivery.live",
        CAMPAIGN_CLAIMED: "notification.member.campaign.claimed.delivery.live",
        CAMPAIGN_DISABLED: "notification.member.campaign.disabled.delivery.live",
        CAMPAIGN_USED: "notification.member.campaign.used.delivery.live",
        EPS_TRANSACTION_FINISHED: "notification.member.transaction.finished.delivery.live",
        MESSAGE_READ: "member.message.read",
        SMART_BUY_INITIALIZED: "notification.member.payment.smartbuy.initialized.delivery.live",
        SMART_BUY_ACTIVATED: "notification.member.payment.smartbuy.activated.delivery.live",
        SMART_BUY_NOT_AUTHORIZED: "notification.member.payment.smartbuy.not_authorized.delivery.live",
        SMART_BUY_PACKAGE_CHANGED: "notification.member.payment.smartbuy.package_changed.delivery.live",
        SMART_BUY_DISABLED: "notification.member.payment.smartbuy.disabled.delivery.live",
        SMART_BUY_REWARD: "notification.member.payment.smart_buy.reward.created.delivery.live",
        SMART_BUY_STARTED: "notification.member.payment.smartbuy.started.delivery.live",
        POST_IDENT_SUCCESS: "notification.member.age_verification.postident.success.delivery.live",
        THREAD_UPDATED: "notification.member.thread.updated.delivery.live",
        MESSAGE_DISCOUNT_CHANGED: "notification.member.messenger_message_discount_changed.delivery.live",
        SURPRISE_CONFIGURATION_CHANGED: "notification.member.surprise_configuration.changed.delivery.live",
        PRO_MEMBERSHIP_SUBSCRIBED: "notification.pro_membership.member.subscribed.delivery.live",
        INVISIBLE_MODE_STATUS_CHANGED: "notification.chat.invisible_mode_status_changed.delivery.live",
        AGE_VERIFICATION_COMPLETED: "notification.member.age_verification.completed.delivery.live",
    },
    CHANNEL: {
        CONTENT_LIKED: "notification.channel.content.liked.delivery.live",
        CONTENT_COMMENTED: "notification.channel.content.commented.delivery.live",
    },
    THREAD: {
        MESSAGE_CHANGED: "thread.last.message.change",
        SEEN_BY_PERFORMER: "notification.member.messenger.v3.thread.seen.by_performer.delivery.live",
    },
    SHOP: {
        PRODUCT_GROUP_CONTRIBUTED: "shop.product_group.contributed",
        PAYMENT_ORDER_PLACED: "notification.member.shop.payment_order.placed.delivery.live",
        PAYMENT_ORDER_FAILED: "notification.member.shop.payment_order.failed.delivery.live",
    },
    INTERCOM: {
        DATA_CHANGED_LIVE: "notification.member.intercom.data_changed.delivery.live",
        DATA_CHANGED_HISTORY: "notification.member.intercom.data_changed.delivery.history",
    },
    USER_FEATURE: {
        MEMBER_UPDATED: "notification.user_feature.member_updated.delivery.live",
    },
    CHALLENGE: {
        ALL_GOALS_REACHED: "notification.challenge.participant.all_goals_reached.delivery.live",
    },
    TRACKING_PIXEL: {
        RETARGETING_CREATED: "notification.member.retargeting.created.delivery.live",
    },
};
